/** @format */
import { ModelSearchResultsType } from '@toucan/common/services/search/constants';

import { useFeatureFlag } from '@toucan/client/global/feature-flag';

export const useShouldUseSemanticSearch = (
    type: ModelSearchResultsType
): boolean => {
    const isSemanticSearchEnabled =
        useFeatureFlag('TUR-3223-(semantic-search-endpoint)')?.isEnabled ??
        false;

    return isSemanticSearchEnabled && type === ModelSearchResultsType.SEARCH;
};
